export { default as ConnectedKbSuggestedArticlesWrapper } from './kb-suggestions-connected';
